// assets
import { TeamOutlined, BarChartOutlined } from "@ant-design/icons";
import Permissions from "constants/Permissions";

// ==============================|| MENU ITEMS - UNITS ||============================== //

const units = {
    id: "group-units",
    title: "Org Structure",
    type: "group",
    appModule: "ORG_STRUCTURE",
    children: [
        {
            id: "units",
            title: "Units",
            authority: Permissions.AdministrationSection.Settings,
            type: "item",
            url: "/administration/units",
            icon: TeamOutlined,
            breadcrumbs: false,
        },
        {
            id: "units-efficiency",
            title: "Units Efficiency",
            authority: Permissions.AdministrationSection.Settings,
            type: "item",
            url: "/unmanned-aerial-vehicles",
            icon: BarChartOutlined,
            breadcrumbs: false,
        },
    ],
};

export default units;
